var exports = {
  "i": "xaee3c4fa--8c0b70--wrapper",
};

module.exports = exports;
